import { render, staticRenderFns } from "./NotificationsModal.vue?vue&type=template&id=f0c40a32&scoped=true"
import script from "./NotificationsModal.vue?vue&type=script&lang=js"
export * from "./NotificationsModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationsModal.vue?vue&type=style&index=0&id=f0c40a32&prod&scoped=true&lang=css"
import style1 from "./NotificationsModal.vue?vue&type=style&index=1&id=f0c40a32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c40a32",
  null
  
)

export default component.exports